<div class="led-wrapper">
  @if (!entityId) {
    <p class="no-selection">Select a legal entity to view details.</p>
  }
  @if (entityId) {
    <div class="led-content">
      <app-az-tabs
        [tabs]="tabs"
        [activeTabId]="activeTabId()"
        (activeTabChange)="onTabChange($event)"
      >
        <div
          class="tab-content overlay-scroll--custom"
          scrollActivity
          [scrollActivityCustom]="true"
        >
          @if (activeTabId() === 'info') {
            <app-legal-entity-information [entityId]="entityId" />
          }
          @if (activeTabId() === 'documents') {
            <app-legal-entity-documents [entityId]="entityId" />
          }
        </div>
      </app-az-tabs>
    </div>
  }
</div>
